module.exports = __webpack_public_path__ + "static/media/TaliaBahar_DesignResume.e41bbafe.pdf";